export class FacilityDetail {
  productionActivityId: number;
  businessCatogoryId: number;
  activityProcessFeedstockId: number;
  productionActivityName: string;
  repEstProbPercentage: string;
  repEstSupplyMode: string;
  repEstBusinessModel: string;
  awardedSupplyMode: string;
  awardedBusinessModel: string;
  estAcquisitionBusinessModel: string;
  actEstProbPercentage: string;
  actEstSupplyMode: string;
  actEstAwardYear: number;
  soeToSOGConvMonthYear: Date;
  process: string;
  feedstock: string;
  industry: string;
  industrySegment: string;
  involvesGasification: string;
  combined: string;
  prospectDriver: string;
  awardedDriver: string;
  currency: string;
  capacity: number;
  capacityUOM: string;
  constructionStartupYear: number;
  repEstAwardYear: number;
  probability: number;
  onStreamDate: Date;
  estOnstreamDate: Date;
  shutDownDate: Date;
  capitalInvestment: number;
  gasifierCapital: number;
  hydrogenOtherCapital: number;
  status: string;
  asuCapital: number;
  smrCapital: number;
  syngasMolarRatio: number;
  notes: string;
  industryServedNotes: string;
  igccFlag: boolean;
  acquisitionOpportunityFlag: boolean;
  replacementOpportunityFlag: boolean;
  productionFacilityInfoSource: string;
  announcementTitle: string;
  announcementDate: Date;
  sourceLinks: SourceLink[];
  liquidO2TPD: number;
  liquidN2TPD: number;
  liquidArgonTPD: number;
  liquidH2TPD: number;
  phase: number;
  generateMerchantLiquid: boolean;
  attachments: Attachment[];
  existingAttachments: Attachment[];
  industryServedBusinessCategoryId: number;
  primaryProductId: string;
}

export class Attachment {
  fileName: string;
  fileType: number;
  content: string;
}

export class SourceLink {
  url: string;
}
